module.exports = __webpack_public_path__ + "img/TingfengGu.6fa4a162.jpg";